import { useState } from "react";
import { FileSpreadsheet, Mail } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api from "@/lib/api";

const GROUPS = [["", "Tutti gli eventi"], ["win", "Vincite"], ["lose", "Non vincite"], ["errors", "Errori (codice invalido/usato, invii falliti)"], ["photo", "Foto scontrino"], ["campaign", "Campagne e classifica"]];

export function ConversationExport({ contestId }) {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [allContests, setAllContests] = useState(false);
  const [group, setGroup] = useState("");
  const [sending, setSending] = useState(false);
  const sendWeekly = async () => {
    setSending(true);
    try {
      const r = await api.whatsappWeeklyExportSend(true);
      toast.success(`Export ${r.period}: ${r.messages} messaggi, inviato a ${r.sent.length} admin`);
    } catch { toast.error("Invio export settimanale non riuscito"); } finally { setSending(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 px-4 py-2 border-b border-border bg-secondary/20 text-xs" data-testid="whatsapp-export-bar">
      <span className="text-muted-foreground">Esporta periodo:</span>
      <Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="h-7 w-36 text-xs" data-testid="whatsapp-export-from" />
      <span className="text-muted-foreground">→</span>
      <Input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="h-7 w-36 text-xs" data-testid="whatsapp-export-to" />
      <select value={group} onChange={(e) => setGroup(e.target.value)} className="h-7 rounded-md border border-border bg-background px-2 text-xs" data-testid="whatsapp-export-group">
        {GROUPS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      <label className="flex items-center gap-1 text-muted-foreground cursor-pointer">
        <input type="checkbox" checked={allContests} onChange={(e) => setAllContests(e.target.checked)} data-testid="whatsapp-export-all" /> Tutti i concorsi
      </label>
      <a href={api.whatsappExportUrl(allContests ? null : contestId, from, to, group)} className="ml-auto inline-flex items-center gap-1 h-7 px-2 rounded-md border border-border hover:bg-secondary/60" data-testid="whatsapp-export-button">
        <FileSpreadsheet className="h-3.5 w-3.5" /> Esporta Excel
      </a>
      <Button size="sm" variant="ghost" className="h-7 text-xs gap-1" onClick={sendWeekly} disabled={sending} title="Invia subito via email agli admin l'Excel della settimana scorsa (ogni lunedì alle 7:00 parte in automatico)" data-testid="whatsapp-weekly-export-send">
        <Mail className="h-3.5 w-3.5" /> Invia ora export settimanale
      </Button>
    </div>
  );
}
